import { type ApiClient, createClient } from "@msuite/server/client";

const SERVER_URL = process.env.PUBLIC_SERVER_URL as string;

export const client: ApiClient = createClient(SERVER_URL, {
	fetch: async (input: RequestInfo | URL, requestInit?: RequestInit) => {
		return fetch(input, {
			method: requestInit?.method ?? "GET",
			headers: {
				"content-type": "application/json",
				Connection: "keep-alive",
				// Named rather than sniffed: the server files an attendance under the client that
				// started it, and a Tauri build's user agent is not a browser's.
				"X-MSuite-Client": "web",
				...requestInit?.headers,
			},
			credentials: "include",
			body: requestInit?.body ?? null,
		});
	},
});
